import * as React from "react";
import { useLocation } from "react-router-dom";

/**
 * BrowserRouter keeps the scroll position across navigations. Reset it on a
 * path change — but not when only the hash changed, or in-page anchors stop
 * working.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, hash]);

  return null;
};

export { ScrollToTop };
export default ScrollToTop;
